export default function getAddonType(addon) {
  return Object.keys(addon)[0];
}